'use strict';

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isIp = require('is-ip');

var defaults = {
  timeout: 5000
};
var urls = {
  v4: 'https://ipv4.icanhazip.com/',
  v6: 'https://ipv6.icanhazip.com/'
};
var fallbackUrls = {
  v4: 'https://api.ipify.org',
  v6: 'https://api6.ipify.org'
};
var xhr;

var sendXhr =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, options, version) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              xhr = new XMLHttpRequest();
              xhr.addEventListener('error', reject, {
                once: true
              });
              xhr.addEventListener('timeout', reject, {
                once: true
              });
              xhr.addEventListener('load', function () {
                var ip = xhr.responseText.trim();

                if (!ip || !isIp[version](ip)) {
                  reject();
                }

                resolve(ip);
              }, {
                once: true
              });
              xhr.open('GET', url);
              xhr.timeout = options.timeout;
              xhr.send();
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendXhr(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var queryHttps =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(version, options) {
    var ip;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return sendXhr(urls[version], options, version);

          case 3:
            ip = _context2.sent;
            _context2.next = 17;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            _context2.prev = 8;
            _context2.next = 11;
            return sendXhr(fallbackUrls[version], options, version);

          case 11:
            ip = _context2.sent;
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t1 = _context2["catch"](8);
            throw new Error('Couldn\'t find your IP');

          case 17:
            return _context2.abrupt("return", ip);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6], [8, 14]]);
  }));

  return function queryHttps(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

queryHttps.cancel = function () {
  xhr.abort();
};

module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread({}, defaults, {}, options));
};

module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread({}, defaults, {}, options));
};